export default {
  '--app-bar-color': '#272727'
};